<template>
  <div
    style="min-height: calc(100vh - 160px)"
    v-loading="homeLoading"
    element-loading-text="数据处理中......"
  >
    <div>
      <div>
        <div class="title">
          <div class="title--newFont">{{ $t("发料明细") }}</div>
          <div style="text-align: right">
            <el-button class="btnTwo" @click="backHome" size="small">{{
              $t("返回")
            }}</el-button>
          </div>
        </div>
        <div v-if="singleData.statusCheck == 1">
          <div class="checkImg">
            <img
              style="max-width: 100%; max-height: 100%"
              src="@/assets/images/examine.png"
            />
          </div>
        </div>
      </div>
      <hr />
      <!-- 操作栏 -->
      <div style="margin: 10px 0; font-size: 16px; font-weight: bold; color: #08a1b8">
        丨{{ $t("基本信息") }}
      </div>
      <div style="margin-bottom: 10px">
        <el-descriptions
          direction="horizontal"
          :key="key"
          :size="'small'"
          :column="5"
          :label-style="labelStyle"
          :contentStyle="contentStyle"
          border
        >
          <el-descriptions-item>
            <template slot="label">{{ $t("发料单号") }}</template>
            <span>{{ singleData.outsourcingRequisitionDocNumber }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("全局搜索码") }}</template>
            <span>{{ singleData.globalSearchNumber }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("发料日期") }}</template>
            <span>{{
              formatDate(singleData.baseRequisitionTime)
            }}</span> </el-descriptions-item
          ><el-descriptions-item>
            <template slot="label">{{ $t("开单人") }}</template>
            <span>{{ singleData.baseDrawerName }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("收货确认人") }}</template>
            <span>{{ singleData.baseConfirmmanName }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div style="margin: 10px 0; font-size: 16px; font-weight: bold; color: #08a1b8">
        {{ $t("丨委外单信息") }}
      </div>
      <div style="margin-bottom: 10px">
        <el-descriptions
          direction="horizontal"
          :key="key"
          :size="'small'"
          :column="5"
          :label-style="labelStyle"
          :contentStyle="contentStyle"
          border
        >
          <el-descriptions-item>
            <template slot="label">{{ $t("委外单号") }}</template>
            <span>{{ routeQuery.outsourcingDocNumber }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("委外产品编号") }}</template>
            <span>{{ routeQuery.materialNumber }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("委外产品名称") }}</template>
            <span>{{ routeQuery.materialName }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("委外产品规格") }}</template>
            <span>{{ specListShow(routeQuery.materialSpecDesc) }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("委外产品单位") }}</template>
            <span>{{ routeQuery.materialUnitName }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <!-- 内容 -->
      <div style="margin: 10px 0; font-size: 16px; font-weight: bold; color: #08a1b8">
        {{ $t("丨发料信息") }}
      </div>
      <div>
        <myTable
          :overflow="true"
          :id="'myTableOne'"
          :columnType="'columnIndex'"
          :list="itemList"
          :titleList="itemTitleList"
          :tableBtnList="itemTableBtnList"
          @btnClick="productBtnClick"
          @inputNumberClick="inputNumberClick"
          @cellClickEvent="cellClickEvent"
          ref="myTableOne"
        ></myTable>
      </div>
      <div>
        <el-input
          type="textarea"
          disabled
          v-model="singleData.remark"
          :placeholder="$t('备注')"
          rows="5"
        ></el-input>
      </div>
    </div>
  </div>
</template>
<script>
import { outsorRequisitionDoc_view } from "@/api/myController/outsourcing";
export default {
  props: {
    // 页面传进来判断的值
    routeType: {
      type: Array,
      default: undefined,
    },
    // 页面传进来的值
    routeQuery: {
      default: () => ({}),
    },
    singleData: {
      default: () => ({}),
    },
    itemList: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
  },
  components: {},
  data() {
    return {
      homeLoading: false,
      // ------------------------------
      itemTableBtnList: [],
      itemTitleList: [
        {
          id: 3,
          name: this.$t("物料编号"),
          value: "baseMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
        },
        {
          id: 4,
          name: this.$t("物料名称"),
          value: "baseMaterialName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
        },
        {
          id: 2,
          name: this.$t("规格型号"),
          value: "specifications",
          fixedState: false,
          isShow: true,
          dataType: "textList",
          alwaysEditState: false,
          canEdit: false,
        },
        {
          id: 2,
          name: this.$t("客户料号"),
          value: "baseCustomerMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          alwaysEditState: false,
          canEdit: false,
          width: 180,
        },
        {
          id: 6,
          name: this.$t("单位"),
          value: "baseMaterialUnitName",
          dataType: "number",
          fixedState: false,
          isShow: true,
          canEdit: false,
        },
        {
          id: 10,
          name: this.$t("申请数量"),
          value: "baseRequisitionQuantity",
          fixedState: false,
          isShow: true,
          dataType: "number",
          canEdit: false,
          alwaysEditState: false,
        },
        {
          id: 11,
          name: this.$t("备注"),
          value: "remark",
          fixedState: false,
          isShow: true,
          dataType: "textarea",
          canEdit: false,
          alwaysEditState: false,
        },
      ],

      // 标题样式
      labelStyle: {
        "text-align": "center",
        "font-size": "14px",
        "font-weight": "700",
        color: "#666",
        width: "120px",
        height: "42px !important",
        padding: "0 5px !important",
        "word-break": "keep-all",
      },
      contentStyle: {
        width: "220px",
        height: "42px !important",
        padding: "5px !important",
        "min-width": "120px",
      },
    };
  },
  created() {
    console.log("------------", this.routeQuery);
    this.getList();
  },
  methods: {
    // 多语言
    $t(value) {
      return value;
    },
    //
    getList() {
      this.homeLoading = true;
      outsorRequisitionDoc_view({
        outsourcingRequisitionDocId: this.routeQuery.outsourcingRequisitionDocId,
      }).then((res) => {
        res.data.data.outsorRequisitionDocDetailList.forEach((item) => {
          res.data.data.statusMaterialRequisition = item.statusMaterialRequisition;
          try {
            item.specifications = JSON.parse(item.baseSpecgroupDesc);
          } catch (error) {
            item.specifications = [];
          }
          item.valueMaterialQuantity = item.baseRequisitionQuantity;
          item.valueUnsendQuantity = item.valueUnrequisitionQuantity;
        });
        this.itemList = res.data.data.outsorRequisitionDocDetailList;
        this.singleData = res.data.data;
        this.homeLoading = false;
      });
    },
    formatDate(time) {
      return this.$moment(time).format("YYYY-MM-DD"); // 获取当前时间
    },
    backHome() {
      this.$emit("backHome");
    },
    cellClickEvent(row, column) {
      switch (column.field) {
        default:
          break;
      }
    },
    specListShow(list) {
      try {
        list = JSON.parse(list);
      } catch (error) {
        list = [];
      }
      let text = "";
      try {
        for (let i = 0; i < list.length; i++) {
          let kong = i == list.length - 1 ? "" : "/";
          text += list[i].specKey + ":" + list[i].specValue + kong;
        }
      } catch (error) {}
      return text;
    },
  },
};
</script>
<style scoped>
.span {
  margin-right: 20px;
  color: #08a1b8;
}
.input {
  width: 100%;
}

.btnOne {
  background: #08a1b8;
  color: white;
}

.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
}

.title----font {
  color: rgb(8, 161, 184);
  position: relative;
  margin-left: 47%;
  font-size: 25px;
  font-weight: bold;
}

.title--button {
  position: absolute;
  margin-left: 1px;
  margin-top: 0.1%;
}
.checkImg {
  height: 75px;
  width: 150px;
  position: absolute;
  top: 80px;
  right: 20px;
  z-index: 99;
  /* opacity: 0.5; */
  transform: rotate(-10deg);
}
</style>
